import Route from '@ember/routing/route';
import { get, set } from '@ember/object';
import RSVP from 'rsvp';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import TaskValidation from '../../../../validations/task';

export default Route.extend({
  abilities: service(),
  currentUser: service(),
  contactsCache: service(),
  fundsService: service(),
  navbarSettings: service(),
  store: service(),

  queryParams: {
    contactId: {},
    fromDetailPage: {},
  },

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    let navbarTitle = null;
    let returnToContactDetailsPage = params.fromDetailPage === 'true';
    let recordPromise = null;
    let contact = null;
    if (params.taskId === 'add') {
      let userId = this.abilities.hasAbility('assign_tasks')
        ? this.currentUser.id
        : null;
      recordPromise = RSVP.resolve(
        this.store.createRecord('task', {
          contactId: params.contactId,
          userId,
        }),
      );
      if (!isEmpty(params.contactId)) {
        contact = this.contactsCache.getById(params.contactId);
      }
      if (returnToContactDetailsPage && !isEmpty(contact)) {
        navbarTitle = get(contact, 'name');
      } else {
        navbarTitle = 'Add Task';
      }
    } else {
      recordPromise = this.store.findRecord('task', params.taskId);
      navbarTitle = 'Edit Task';
    }
    set(this, 'navbarSettings.title', navbarTitle);
    return recordPromise.then((record) => {
      if (returnToContactDetailsPage && !isEmpty(get(record, 'contactId'))) {
        contact = this.contactsCache.getById(get(record, 'contactId'));
        set(this, 'navbarSettings.title', get(contact, 'name'));
      }

      return {
        record,
        contact,
        changeset: new Changeset(
          record,
          lookupValidator(TaskValidation),
          TaskValidation,
        ),
        saved: false,
        returnToContactDetailsPage: returnToContactDetailsPage,
      };
    });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
